export const dcat = ['Current Day', 'Last Week', 'Last 30 Days', 'All'];

export const liq = [
    '0-2.5',
    '2.5-5',
    '5-10',
    '10-20',
    '20-30',
    '30-50',
    '50-100',
    '100-200',
    '200-500',
    '>500',
    'N/A',
];

export const mcap = [
    '0-.25',
    '.25-1.5',
    '1.5-10',
    '10-25',
    '25-100',
    '>100',
    'N/A',
];

export const svol = ['0-.1', '.1-.2', '.2-.5', '.5-1', '1-5', '>5', 'N/A'];

export const side = {
    /* eslint-disable @typescript-eslint/naming-convention */
    B: `BUY`,
    S: `SELL`,
    SS: `SS`,
    /* eslint-enable @typescript-eslint/naming-convention */
};
